<template>
  <div class="pay_jump_div">
    <van-loading type="spinner" color="#edf2fa" />
  </div>
</template>

<script>

import { url_to_query } from '@/plugins/getUrlParam'
export default {
  name: 'payJump',
  data () {
    return {
    }
  },
  mounted () {
    console.log('same page mounted')
    const params = url_to_query() || {}
    if (params?.orderNumbers){
      let userAgent = navigator.userAgent.toLowerCase()
      if (userAgent.indexOf('miniprogram') !== -1) {
        console.log('在微信小程序中打开的webview')
        console.log('this.orderNumbers:', params?.orderNumbers)
        const url = '/package-user/pages/order-detail/order-detail?orderNum=' + params?.orderNumbers
       /*  wx.miniProgram.reLaunch({
          url: url
        }) */
        wx.miniProgram.navigateTo({
          url: url
        })
      }
    }
  },
  computed: {},
  methods: {

  }
}
</script>

<style lang="less" scoped>
.pay_jump_div{
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  background: white;
}
</style>
